import { GetServerTime } from './GetServerTime';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { Total } from './Total';
import moment from 'moment';

export const Salida = async (props) => {
  const records = props.userRecords;
  const user = props.userSession;

  //Obtenemos la fecha y hora del servidor
  var serverTime = await GetServerTime();
  const time = serverTime.formatted;

  //Comprueba cuantos registros tenemos diarios
  var longRecord = 0;
  if (records[moment(time).format('DD-MM-YYYY')]) {
    var dailyRecords = records[moment(time).format('DD-MM-YYYY')];
    longRecord = Object.keys(dailyRecords).length;
  }

  if (longRecord !== 0) {
    if (!records[moment(time).format('DD-MM-YYYY')][longRecord - 1].salida) {
      if (parseInt(moment(time).format('HH')) >= 20) {
        alert('Estas intentado fichar fichar una salida pasadas las 20:00 \nEl tiempo total del tramo solo contabilizará hasta las 20:00');
      }
      //Intoduce la salida

      //Introducimos la salida - Upgrade v1
      records[moment(time).format('DD-MM-YYYY')][longRecord - 1].salida = moment(time).format('HH:mm');
      await Total(props, time);
      //prettier-ignore
      await setDoc(doc(db, 'users', user.uid),{
          estadoSesion: "Desconectado"
        }, {merge:true})
    } else {
      alert('Actualmente estas fuera de la empresa');
    }
  } else {
    alert('Actualmente estas fuera de la empresa');
  }
};
